type InitialRiskLike = {
  initialRiskAmount?: unknown;
  initialRisk?: unknown;
  initial_risk?: unknown;
  riskAmount?: unknown;
};

const toPositiveNumber = (value: unknown): number | null => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
};

export function resolveTradeInitialRiskValue(
  trade: InitialRiskLike | null | undefined,
  defaultRiskPerTrade: number | null | undefined = null,
): number | null {
  const explicitRisk = toPositiveNumber(
    trade?.initialRiskAmount ?? trade?.initialRisk ?? trade?.initial_risk ?? trade?.riskAmount,
  );

  if (explicitRisk != null) return explicitRisk;
  return toPositiveNumber(defaultRiskPerTrade);
}
